"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "calendar-month" };
const _hoisted_2 = { class: "flex flex-wrap" };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "caleandar-text" };
const _hoisted_5 = { class: "appointments-block" };
const vue_3 = require("vue");
const CalendarBlock_vue_1 = __importDefault(require("../../../components/frontend/CalendarBlock.vue"));
const TimeBlock_vue_1 = __importDefault(require("../../../components/frontend/TimeBlock.vue"));
const Alert_vue_1 = __importDefault(require("../../../components/Alert.vue"));
const bookAppointmentStore_1 = require("../../../stores/bookAppointment/bookAppointmentStore");
const appointmentStore_1 = require("../../../stores/appointment/appointmentStore");
const i18n_1 = __importDefault(require("../../../common/i18n"));
const i18n_2 = require("../../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Calendar',
    props: {
        timeZoneSetting: {
            type: String,
            default: "Europe/Budapest",
        },
    },
    setup(__props) {
        const props = __props;
        const currentLang = (0, vue_3.computed)(() => i18n_2.i18n.locale.value);
        const localeMap = {
            hu: "hu-HU",
            ro: "ro-RO",
            en: "en-GB",
        };
        //import dateInterface from "../../../stores/appointment/Date"
        const errorMessage = (0, vue_3.ref)("");
        const currentDate = new Date();
        let currentYear = (0, vue_3.ref)(currentDate.getFullYear());
        let currentMonth = (0, vue_3.ref)(currentDate.getMonth());
        let availableLeftArrow = (0, vue_3.ref)(false);
        let availableRightArrow = (0, vue_3.ref)(true);
        let showTimes = (0, vue_3.ref)(false);
        const Months = [
            i18n_1.default.trans("January", "January", "frontend_calendar_block"),
            i18n_1.default.trans("February", "February", "frontend_calendar_block"),
            i18n_1.default.trans("March", "March", "frontend_calendar_block"),
            i18n_1.default.trans("April", "April", "frontend_calendar_block"),
            i18n_1.default.trans("May", "May", "frontend_calendar_block"),
            i18n_1.default.trans("June", "June", "frontend_calendar_block"),
            i18n_1.default.trans("July", "July", "frontend_calendar_block"),
            i18n_1.default.trans("August", "August", "frontend_calendar_block"),
            i18n_1.default.trans("September", "September", "frontend_calendar_block"),
            i18n_1.default.trans("October", "October", "frontend_calendar_block"),
            i18n_1.default.trans("November", "November", "frontend_calendar_block"),
            i18n_1.default.trans("December", "December", "frontend_calendar_block"),
        ];
        const Days = {
            0: i18n_1.default.trans("Monday", "Mon", "frontend_calendar_block"),
            1: i18n_1.default.trans("Tuesday", "Tue", "frontend_calendar_block"),
            2: i18n_1.default.trans("Wednesday", "Wed", "frontend_calendar_block"),
            3: i18n_1.default.trans("Thursday", "Thu", "frontend_calendar_block"),
            4: i18n_1.default.trans("Friday", "Fri", "frontend_calendar_block"),
            5: i18n_1.default.trans("Saturday", "Sat", "frontend_calendar_block"),
            6: i18n_1.default.trans("Sunday", "Sun", "frontend_calendar_block"),
        };
        const appointmentsStore = (0, appointmentStore_1.useAppointmentStore)();
        const bookAppointmentStore = (0, bookAppointmentStore_1.useBookAppointmentStore)();
        let options = {
            hour: "2-digit",
            minute: "2-digit",
            timeZone: props.timeZoneSetting,
        };
        /*
        watch(
          [
            currentYear,
            currentMonth,
            bookAppointmentStore.tyreFittingServiceSKU,
            bookAppointmentStore.reservedServiceLocationId,
          ],
          async () => {
            // Aszinkron műveletek
            if (
              bookAppointmentStore.tyreFittingServiceSKU &&
              bookAppointmentStore.reservedServiceLocationId
            ) {
              await getMonthDays();
            }
            // További műveleteks
          },
          { immediate: true } // Azonnali futtatás bekapcsolva
        );*/
        (0, vue_3.watch)(() => [
            currentYear.value,
            currentMonth.value,
            bookAppointmentStore.tyreFittingServiceSKU,
            bookAppointmentStore.reservedServiceLocationId,
            appointmentsStore.reload,
        ], ([newYear, newMonth, newServiceSku, newLocationId, reload]) => {
            if ((newYear && newMonth && newServiceSku && newLocationId) || reload) {
                getMonthDays();
            }
        }, { immediate: true } // Azonnali futtatás bekapcsolva
        );
        let dates = (0, vue_3.ref)([]);
        let Times = (0, vue_3.ref)([]);
        async function getMonthDays() {
            await appointmentsStore
                .getAppointments(currentYear.value, currentMonth.value, bookAppointmentStore.reservedServiceLocationId, bookAppointmentStore.tyreFittingServiceSKU)
                .then(() => {
                Times.value = [];
                removeChecked(".calendar-block.checked");
                removeChecked(".time-block.checked");
                bookAppointmentStore.bookDate = "";
                bookAppointmentStore.bookTime = "";
                errorMessage.value = "";
            })
                .catch((error) => {
                Times.value = [];
                removeChecked(".calendar-block.checked");
                removeChecked(".time-block.checked");
                bookAppointmentStore.bookDate = "";
                bookAppointmentStore.bookTime = "";
                errorMessage.value = error.toString();
                showTimes.value = false;
            });
            dates.value = [];
            let days = [];
            let date = new Date(currentYear.value + "-" + padZero(currentMonth.value + 1) + "-01");
            date.setDate(date.getDate() - (date.getDay() - 1));
            for (let i = 1; i <= 42; i++) {
                let tmpDate = new Date(date);
                let formattedDay = tmpDate.getDate() < 10
                    ? "0" + tmpDate.getDate()
                    : "" + tmpDate.getDate();
                if (tmpDate.getMonth() === currentMonth.value) {
                    const tmpObj = {
                        day: appointmentsStore.dates[formattedDay].day.toString() === "7"
                            ? "0"
                            : appointmentsStore.dates[formattedDay].day.toString(),
                        date: tmpDate,
                        monthDay: appointmentsStore.dates[formattedDay].monthDay,
                        status: appointmentsStore.dates[formattedDay].status,
                        times: appointmentsStore.dates[formattedDay].times,
                    };
                    dates.value.push(tmpObj);
                }
                else {
                    const tmpObj = {
                        day: tmpDate.getDay().toString(),
                        date: tmpDate,
                        monthDay: formattedDay,
                        status: "close",
                        times: [],
                    };
                    dates.value.push(tmpObj);
                }
                days.push(tmpDate);
                date.setDate(date.getDate() + 1);
            }
            return days;
        }
        function incrase() {
            currentMonth.value++;
            if (currentMonth.value >= 12) {
                currentMonth.value = 0;
                currentYear.value++;
            }
            availableRightArrow.value = false;
            availableLeftArrow.value = true;
        }
        function decrase() {
            currentMonth.value--;
            if (currentMonth.value <= -1) {
                currentMonth.value = 11;
                currentYear.value--;
            }
            availableRightArrow.value = true;
            availableLeftArrow.value = false;
        }
        function selectDate(year, month, day, selectedElement) {
            month += 1;
            let formattedDay = day < 10 ? "0" + day : "" + day;
            let formattedMonth = month < 10 ? "0" + month : "" + month;
            const selectedDate = year + "-" + formattedMonth + "-" + formattedDay;
            removeChecked(".calendar-block.checked");
            removeChecked(".time-block.checked");
            selectedElement.classList.add("checked");
            bookAppointmentStore.bookTime = "";
            bookAppointmentStore.serviceBay = null;
            bookAppointmentStore.bookDate = selectedDate;
            Times.value = [];
            /*Object.entries(appointmentsStore.dates[formattedDay].times).forEach(
            ([index, value]) => {
              let tmpTime = new Date(value.time);
              let formattedHour =
                tmpTime.getHours() < 10
                  ? "0" + tmpTime.getHours().toString()
                  : "" + tmpTime.getHours().toString();
              let formattedMinute =
                tmpTime.getMinutes() < 10
                  ? "0" + tmpTime.getMinutes().toString()
                  : "" + tmpTime.getMinutes().toString();
              const tmpTimeObj: timeInterface = {
                bay: value.bay,
                time: new Date(value.time),
                formattedTime: formattedHour + ":" + formattedMinute,
              };
              Times.value.push(tmpTimeObj);
            }
          );*/
            Object.entries(appointmentsStore.dates[formattedDay].times).forEach(([index, value]) => {
                let tmpTime = new Date(value.time);
                // Itt állítsuk be a magyar időzónát
                let formattedTime = tmpTime.toLocaleTimeString(localeMap[currentLang.value] || "en-GB", options);
                const tmpTimeObj = {
                    bay: value.bay,
                    time: new Date(value.time),
                    formattedTime: formattedTime,
                };
                Times.value.push(tmpTimeObj);
            });
            showTimes.value = true;
        }
        function selectTime(hour, minute, serviceBay, selectedElement) {
            let formattedHour = hour < 10 ? "0" + hour.toString() : "" + hour.toString();
            let formattedMinute = minute < 10 ? "0" + minute.toString() : "" + minute.toString();
            removeChecked(".time-block.checked");
            selectedElement.classList.add("checked");
            bookAppointmentStore.serviceBay = serviceBay;
            bookAppointmentStore.bookTime =
                formattedHour + ":" + formattedMinute + ":00";
        }
        function removeChecked(classString) {
            const HTMLelements = document.querySelectorAll(classString);
            HTMLelements.forEach((element) => {
                element.classList.remove("checked");
            });
        }
        function padZero(number) {
            return number < 10 ? "0" + number : number;
        }
        function formatHour(date) {
            return Number(date
                .toLocaleTimeString(localeMap[currentLang.value] || "en-GB", options)
                .split(":")[0]);
        }
        function formatMinute(date) {
            return Number(date
                .toLocaleTimeString(localeMap[currentLang.value] || "en-GB", options)
                .split(":")[1]);
        }
        return (_ctx, _cache) => {
            const _component_font_awesome_icon = (0, vue_2.resolveComponent)("font-awesome-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (errorMessage.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                        key: 0,
                        message: errorMessage.value,
                        icon: ""
                    }, null, 8, ["message"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_1, [
                    ((0, vue_2.unref)(availableLeftArrow))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 0,
                            class: "arrow left",
                            onClick: _cache[0] || (_cache[0] = ($event) => (decrase()))
                        }, [
                            (0, vue_2.createVNode)(_component_font_awesome_icon, { icon: ['fa', 'caret-left'] })
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(currentYear)) + ". " + (0, vue_2.toDisplayString)(Months[(0, vue_2.unref)(currentMonth)]), 1),
                    ((0, vue_2.unref)(availableRightArrow))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 1,
                            class: "arrow right",
                            onClick: _cache[1] || (_cache[1] = ($event) => (incrase()))
                        }, [
                            (0, vue_2.createVNode)(_component_font_awesome_icon, { icon: ['fa', 'caret-right'] })
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 512), [
                    [vue_2.vShow, !errorMessage.value]
                ]),
                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_2, [
                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(Days, (day, index) => {
                        return (0, vue_2.createVNode)(CalendarBlock_vue_1.default, {
                            key: index,
                            label: day,
                            "day-type": "day",
                            class: "text-black pointer-events-none"
                        }, null, 8, ["label"]);
                    }), 64)),
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(dates), (day, index) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CalendarBlock_vue_1.default, {
                            key: index,
                            date: day.date.getDate().toString(),
                            class: (0, vue_2.normalizeClass)({
                                'text-white bg-green cursor-pointer': day.status.toString() === '0',
                                'text-white pointer-events-none bg-[#D5D5D5]': day.status.toString() === 'full',
                                'bg-white pointer-events-none text-[#D5D5D5]': day.status.toString() === 'close',
                                // további feltételes osztályok
                            }),
                            onClick: ($event) => (selectDate((0, vue_2.unref)(currentYear), (0, vue_2.unref)(currentMonth), day.date.getDate(), $event.target))
                        }, null, 8, ["date", "class", "onClick"]));
                    }), 128))
                ], 512), [
                    [vue_2.vShow, !errorMessage.value]
                ]),
                ((0, vue_2.unref)(showTimes))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("bookable_appointments", "Bookable appointments", "frontend_calendar_block")) + " ", 1),
                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(bookAppointmentStore).bookDate), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(Times), (item, index) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TimeBlock_vue_1.default, {
                                    key: index,
                                    time: item.formattedTime ? item.formattedTime.toString() : '',
                                    onClick: ($event) => (selectTime(formatHour(item.time), formatMinute(item.time), item.bay, $event.target))
                                }, null, 8, ["time", "onClick"]));
                            }), 128))
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
